import {
  getStatusRoutine,
  refreshStatusRoutine,
  clearLocalStatusRoutine
} from 'actions';

export const initialState = {
  status: null,
  loading: false,
  refreshing: false,
  error: null,
  lastFetched: null
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case getStatusRoutine.REQUEST: {
      return { ...state, loading: true, error: null };
    }
    case getStatusRoutine.SUCCESS: {
      const { data: { status } } = action.payload;

      return { 
        ...state, 
        status,
        loading: false,
        lastFetched: new Date().toISOString()
      };
    }
    case getStatusRoutine.FAILURE: {
      return { 
        ...state, 
        loading: false,
        error: action.payload?.message || 'Failed to fetch status'
      };
    }
    case refreshStatusRoutine.REQUEST: {
      return { ...state, refreshing: true, error: null };
    }
    case refreshStatusRoutine.SUCCESS: {
      const { data: { status } } = action.payload;

      return { 
        ...state, 
        status,
        refreshing: false,
        lastFetched: new Date().toISOString()
      };
    }
    case refreshStatusRoutine.FAILURE: {
      return { 
        ...state, 
        refreshing: false,
        error: action.payload?.message || 'Failed to refresh status'
      };
    }
    case clearLocalStatusRoutine.SUCCESS: {
      return initialState;
    }
    default: {
      return state;
    }
  };
};

export default reducer;

